<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">C<span class="small">ONTENTS</span></p>
<p class="TOC"><a href="#/Acknowledgments">Acknowledgements</a></p>
<p class="TOC"><a href="#/Introduction">Introduction</a></p>
<p class="TOC1"><a href="#/Chapter1">1. Southern Call to Arms</a></p>
<p class="TOC"><span href="#/Chapter2" title="Link target outside of Sample">2. Federal Invasion and Occupation</span></p>
<p class="TOC"><span href="#/Chapter3" title="Link target outside of Sample">3. Fort Clinch</span></p>
<p class="TOC"><span href="#/Chapter4" title="Link target outside of Sample">4. United States Colored Troops</span></p>
<p class="TOC"><span href="#/Chapter5" title="Link target outside of Sample">5. Reconstruction and Civil War Veterans</span></p>
<p class="TOC1"><span href="#/Notes" title="Link target outside of Sample">Notes</span></p>
<p class="TOC"><span href="#/Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="TOC"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?32a13a1a